import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ALL_CATEGORIES, TRANSACTION_TYPES } from '../types';

const AddTransaction = ({ addTransaction }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    type: TRANSACTION_TYPES.EXPENSE,
    category: 'サブスクリプション',
    amount: '',
    memo: '',
    date: new Date().toISOString().split('T')[0]
  });

  // Handle form input changes
  const handleChange = (field, value) => {
    if (field === 'type') {
      // Reset category when type changes
      const firstCategory = ALL_CATEGORIES[value][0];
      setFormData(prev => ({
        ...prev,
        [field]: value,
        category: firstCategory
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.type || !formData.category || !formData.amount || !formData.date) {
      alert('必須項目を入力してください');
      return;
    }

    if (formData.amount <= 0) {
      alert('金額は0より大きい値を入力してください');
      return;
    }

    setLoading(true);

    const transactionData = {
      ...formData,
      amount: parseInt(formData.amount)
    };

    const result = await addTransaction(transactionData);
    
    if (result.success) {
      alert('取引を追加しました');
      navigate('/dashboard');
    } else {
      alert(result.error || '取引の追加に失敗しました');
    }
    
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="form-container">
        <h1>取引を追加</h1>
        
        <form onSubmit={handleSubmit} className="card">
          {/* Transaction Type */}
          <div className="form-group">
            <label>取引タイプ *</label>
            <div className="radio-group">
              <div className="radio-option">
                <input
                  type="radio"
                  id="income"
                  name="type"
                  value={TRANSACTION_TYPES.INCOME}
                  checked={formData.type === TRANSACTION_TYPES.INCOME}
                  onChange={(e) => handleChange('type', e.target.value)}
                />
                <label htmlFor="income">収入</label>
              </div>
              <div className="radio-option">
                <input
                  type="radio"
                  id="expense"
                  name="type"
                  value={TRANSACTION_TYPES.EXPENSE}
                  checked={formData.type === TRANSACTION_TYPES.EXPENSE}
                  onChange={(e) => handleChange('type', e.target.value)}
                />
                <label htmlFor="expense">支出</label>
              </div>
            </div>
          </div>

          {/* Category */}
          <div className="form-group">
            <label htmlFor="category">カテゴリー *</label>
            <select
              id="category"
              value={formData.category}
              onChange={(e) => handleChange('category', e.target.value)}
              required
            >
              {ALL_CATEGORIES[formData.type].map(category => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          {/* Amount and Date */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="amount">金額 *</label>
              <input
                type="number"
                id="amount"
                value={formData.amount}
                onChange={(e) => handleChange('amount', e.target.value)}
                placeholder="1000"
                min="1"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="date">日付 *</label>
              <input
                type="date"
                id="date"
                value={formData.date}
                onChange={(e) => handleChange('date', e.target.value)}
                required
              />
            </div>
          </div>

          {/* Memo */}
          <div className="form-group">
            <label htmlFor="memo">メモ</label>
            <input
              type="text"
              id="memo"
              value={formData.memo}
              onChange={(e) => handleChange('memo', e.target.value)}
              placeholder="メモ（任意）"
            />
          </div>

          {/* Submit Button */}
          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? '追加中...' : '取引を追加'}
          </button>
        </form>

        {/* Category Guide */}
        <div className="card" style={{ marginTop: '1rem' }}>
          <h3>カテゴリーガイド</h3>
          
          <div style={{ marginBottom: '1rem' }}>
            <h4>収入カテゴリー</h4>
            <ul style={{ marginLeft: '1rem', color: '#666' }}>
              {ALL_CATEGORIES[TRANSACTION_TYPES.INCOME].map(category => (
                <li key={category}>{category}</li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4>支出カテゴリー</h4>
            <ul style={{ marginLeft: '1rem', color: '#666' }}>
              {ALL_CATEGORIES[TRANSACTION_TYPES.EXPENSE].map(category => (
                <li key={category}>{category}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTransaction;